namespace TabAurous {
    export interface ExcelImportRequest extends Serenity.ServiceRequest {
        FileName?: string;
        CreateLabour?: boolean;
    }
}
